import { render, staticRenderFns } from "./IDPhoto.vue?vue&type=template&id=113046c5&scoped=true"
import script from "./IDPhoto.vue?vue&type=script&lang=js"
export * from "./IDPhoto.vue?vue&type=script&lang=js"
import style0 from "./IDPhoto.vue?vue&type=style&index=0&id=113046c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113046c5",
  null
  
)

export default component.exports